import React from "react";
import styled from "styled-components";
import * as Icon from "react-feather";
import { Link } from "react-router-dom";
import { H4, P, TextLink } from "../Texts";
import ExpandableDescription from "../../molecules/ExpandableDescription";
import { Pill } from "../Badges/badge.ssn";
import pillStylesEnum from "../../../shared/fixtures/pillStylesEnum";

const Style = styled.div``;

export const WidgetCard = ({ title, description, img, link, status }) => (
  <Style className="bg-white rounded-lg shadow hover:shadow-md duration-300 p-4 pt-6">
    <div>
      <img src={img} alt={`${title}-widget-banner`} />
    </div>

    <H4 color="#22202D" fontFamily="regular" font className="mt-4 truncate">
      {title}
    </H4>
    <ExpandableDescription
      text_color="#7D7B96"
      className="mt-3"
      fontSize="14px"
      text={description}
      length={100}
      hideMoreOption
    />
    <div className="flex items-center justify-between mt-8">
      {status === "available" ? (
        <Link to={link}>
          <TextLink className="flex items-center gap-3" color="#22202D">
            View <Icon.ArrowRight size={16} color="#22202D" />
          </TextLink>
        </Link>
      ) : (
        <TextLink
          className="flex items-center gap-3 cursor-not-allowed"
          color={status === "available" ? "#22202D" : "#22202D80"}
        >
          View{" "}
          <Icon.ArrowRight
            size={16}
            color={status === "available" ? "#22202D" : "#22202D80"}
          />
        </TextLink>
      )}
      <Pill
        className="capitalize"
        color={pillStylesEnum[status]?.color}
        bg={pillStylesEnum[status]?.bg}
      >
        <P fontSize="14px">{status}</P>
      </Pill>
    </div>
  </Style>
);
